import BaseItemSerializer from './base-item';

export default class QuestionSerializer extends BaseItemSerializer {}
